import type { ReactNode } from 'react';

import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from 'design-system';

interface EmptyStateProps {
  title: string;
  description: string;
  icon: ReactNode;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const content = (title: string, description: string, icon: ReactNode) => (
  <EmptyHeader>
    <EmptyMedia variant='icon'>{icon}</EmptyMedia>
    <EmptyTitle>{title}</EmptyTitle>
    <EmptyDescription>{description}</EmptyDescription>
  </EmptyHeader>
);

export const EmptyState = ({ title, description, icon, setOpen }: EmptyStateProps) => {
  if (setOpen) {
    return (
      <button
        type='button'
        className='w-full rounded-xl border-2 border-dashed border-border'
        onClick={() => {
          setOpen(true);
        }}
      >
        <Empty>{content(title, description, icon)}</Empty>
      </button>
    );
  }

  return <Empty className='border-2 border-border'>{content(title, description, icon)}</Empty>;
};
